// FetchTokenSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchToken } from "./FetchCookie";

// Thunk to fetch token
export const fetchTokenAsync = createAsyncThunk("authToken/fetchToken", async () => {
  const token = await fetchToken();
  return token; // string or null
});

const authTokenSlice = createSlice({
  name: "authToken",
  initialState: {
    token: null,
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.token = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTokenAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTokenAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload || null;
      })
      .addCase(fetchTokenAsync.rejected, (state, action) => {
        state.loading = false;
        state.token = null;
        state.error = action.error?.message || "Failed to fetch token";
      });
  },
});

// Robust selector to support different reducer keys in the store
export const selectToken = (state) =>
  state.authToken?.token ??
  state.authTokenReducer?.token ??
  state.auth?.token ??
  null;

export const { logout } = authTokenSlice.actions;
export default authTokenSlice.reducer;